import React from 'react';
import View from './view';

const LoaderBar = ({ isVisible }) => <View isVisible={isVisible} />;

export {
  LoaderBar,
};
